import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ModalController, NavController, PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { MdlReportesDescargablesPage } from 'src/app/pages/mdl-reportes-descargables/mdl-reportes-descargables.page';

import { MasivosService } from 'src/app/services/masivos.service';

@Component({
  selector: 'app-masivos-popover',
  templateUrl: './masivos-popover.component.html',
  styleUrls: ['./masivos-popover.component.scss'],
})
export class MasivosPopoverComponent implements OnInit {

  @Input() selectedMenu: string;

  @Output() cambiarReporteEncuestas = new EventEmitter<boolean>();
  @Output() cambiarReportePlantillas = new EventEmitter<boolean>();
  @Output() cambiarMostrarMasivos = new EventEmitter<boolean>();

  idAdmin: any;
  storageUsuario: any;

  menu = {
    plantillas: false,
    informes: false
  };

  constructor(
    private storage: Storage,
    public modalController: ModalController,
    private popoverController: PopoverController,
    private navCtrl: NavController,
    private masivosService: MasivosService,
  ) { }

  ngOnInit() {
    this.storage.get('usuario').then((usuario) => {
      this.storageUsuario = usuario;
    })
      .then(() => {
        this.idAdmin = this.storageUsuario.idAdmin;
      });

    if (this.selectedMenu) {
      this.activateMenu(this.selectedMenu);
    }
  }

  activateMenu(menuName: string) {
    this.menu = {
      plantillas: false,
      informes: false
    };

    if (menuName in this.menu) {
      this.menu[menuName] = true;
    }
  }

  ir(ruta) {
    this.navCtrl.navigateForward('/folder/' + ruta)
      .then(() => {
        if (ruta === 'inicio') {
          window.location.reload();
        }

        this.closePopover();
      });
  }

  toggleReporteEncuestas() {
    this.masivosService.setMostrarReporteEncuestas(true);
    this.masivosService.setMostrarReportePlantillas(false);
    this.masivosService.setMostrarMasivos(false);
    this.closePopover();
  }

  toggleReportePlantillas() {
    this.masivosService.setMostrarReporteEncuestas(false);
    this.masivosService.setMostrarReportePlantillas(true);
    this.masivosService.setMostrarMasivos(false);
    this.closePopover();
  }

  async modalReportes() {
    const modal = await this.modalController.create({
      component: MdlReportesDescargablesPage,
      cssClass: 'animate__animated animate__slideInRight',
      showBackdrop: false,
      mode: 'ios',
      componentProps: {
        idAdmin: this.idAdmin,
      },
    });

    this.closePopover();
    return await modal.present();
  }

  async closePopover() {
    await this.popoverController.dismiss();
  }

}
